module.exports = __webpack_public_path__ + "static/media/viking_armor.30201977.png";